<div class="seychelles-flipbook">
  <div class="viewer-card" #fullscreenTarget [class.viewer-fullscreen]="isFlipbookFullscreen">
    <div class="loading-message" *ngIf="loading">
      <p-progressSpinner strokeWidth="5" [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
    </div>
    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <!-- Left arrow -->
    <button type="button" class="page-arrow page-arrow-left" [disabled]="currentPage <= 1" (click)="previousPage()">
      ‹
    </button>
    <div class="page-display" *ngIf="!loading && !errorMessage">
      <div class="flipbook-zoom" [ngStyle]="{ transform: flipbookTransform }">
        <div class="flipbook-container" #flipBookContainer>
          <div
            class="flip-page"
            *ngFor="let image of pageImages; let i = index"
            [attr.data-density]="i === 0 || i === pageImages.length - 1 ? 'hard' : 'soft'"
          >
            <div class="flip-page-content">
              <img [src]="image" alt="PDF page" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right arrow -->
    <button
      type="button"
      class="page-arrow page-arrow-right"
      [disabled]="currentPage >= totalPages"
      (click)="nextPage()"
    >
      ›
    </button>

    <!-- Bottom toolbar -->
    <div class="bottom-toolbar">
      <div class="progress-line">
        <div class="progress-dot" [style.left.%]="progressPercent"></div>
      </div>
      <div class="toolbar-content">
        <!-- Left side -->
        <div class="toolbar-left">
          <span class="page-number"> {{ currentPage }} / {{ totalPages || 0 }} </span>
          <span class="brand">
            <img src="assets/images/bannerlogo.png" alt="Seychelles" class="logo-image" />
            <span>Seychelles</span>
          </span>
        </div>
        <div class="toolbar-center">
          <!-- Grid view -->
          <button
            type="button"
            class="toolbar-icon-btn"
            title="Grid view"
            [class.active]="showGrid"
            (click)="toggleGrid()"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
            </svg>
          </button>
          <!-- Zoom out -->
          <button
            type="button"
            class="toolbar-icon-btn"
            title="Zoom out"
            [disabled]="zoom <= minZoom"
            (click)="zoomOut()"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="6" y1="12" x2="18" y2="12"></line>
            </svg>
          </button>
          <div class="zoom-slider">
            <div class="zoom-slider-fill" [style.width.%]="((zoom - minZoom) / (maxZoom - minZoom)) * 100"></div>
          </div>
          <!-- Zoom in -->
          <button
            type="button"
            class="toolbar-icon-btn"
            title="Zoom in"
            [disabled]="zoom >= maxZoom"
            (click)="zoomIn()"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>

        <!-- Search -->
        <div class="toolbar-right">
          <!-- Download -->
          <button type="button" class="toolbar-icon-btn" title="Download PDF" (click)="downloadPdf()">
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3v12"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="5" y1="21" x2="19" y2="21"></line>
            </svg>
          </button>

          <button
            type="button"
            class="toolbar-icon-btn"
            title="Search"
            [class.active]="showSearch"
            (click)="toggleSearch()"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="7"></circle>
              <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
            </svg>
          </button>

          <!-- Share -->
          <button
            type="button"
            class="toolbar-icon-btn"
            title="Share"
            [class.active]="showShare"
            (click)="toggleShare()"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.7" y1="10.7" x2="15.3" y2="6.3"></line>
              <line x1="8.7" y1="13.3" x2="15.3" y2="17.7"></line>
            </svg>
          </button>

          <!-- Fullscreen -->
          <button type="button" class="toolbar-icon-btn" title="Fullscreen" (click)="toggleFullscreen()">
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="9 3 3 3 3 9"></polyline>
              <polyline points="15 3 21 3 21 9"></polyline>
              <polyline points="21 15 21 21 15 21"></polyline>
              <polyline points="3 15 3 21 9 21"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Search bar (Issuu-style pill, top-center) -->
    <div class="fb-search-bar" *ngIf="showSearch">
      <button type="button" class="fb-search-icon" title="Search" [disabled]="isSearching" (click)="searchPdf()">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="7"></circle>
          <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
        </svg>
      </button>

      <input
        type="text"
        class="fb-search-input"
        placeholder="Search keywords"
        [(ngModel)]="searchText"
        (keyup.enter)="searchPdf()"
      />

      <span class="fb-search-count" *ngIf="searchResults.length > 0">
        {{ activeSearchIndex + 1 }}/{{ searchResults.length }}
      </span>
      <span class="fb-search-count fb-no-result" *ngIf="searchText && !isSearching && searchResults.length === 0">
        0/0
      </span>
      <span class="fb-search-count" *ngIf="isSearching">…</span>

      <div class="fb-search-divider"></div>

      <button
        type="button"
        class="fb-search-nav"
        title="Previous result"
        [disabled]="searchResults.length === 0"
        (click)="goToPreviousSearchResult()"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 15 12 9 18 15"></polyline>
        </svg>
      </button>
      <button
        type="button"
        class="fb-search-nav"
        title="Next result"
        [disabled]="searchResults.length === 0"
        (click)="goToNextSearchResult()"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      <button type="button" class="fb-search-close" title="Close" (click)="showSearch = false">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="6" y1="6" x2="18" y2="18"></line>
          <line x1="18" y1="6" x2="6" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Share bar (Issuu-style full-width, black) -->
    <div class="fb-share-bar" *ngIf="showShare">
      <label class="fb-start-at">
        <input type="checkbox" [(ngModel)]="startAtEnabled" />
        <span>Start at</span>
        <input
          type="number"
          min="1"
          [max]="totalPages || 1"
          class="fb-start-at-page"
          [(ngModel)]="startAtPage"
          [disabled]="!startAtEnabled"
        />
      </label>

      <div class="fb-share-link">
        <span class="fb-share-link-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1.5 1.5"></path>
            <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1.5-1.5"></path>
          </svg>
        </span>
        <input type="text" class="fb-share-url" readonly [value]="shareUrl" />
      </div>

      <button type="button" class="fb-copy-link" (click)="copyShareLink()">
        {{ copied ? 'Copied' : 'Copy link' }}
      </button>

      <div class="fb-share-socials">
        <a
          class="fb-share-social"
          title="Facebook"
          [href]="'https://www.facebook.com/sharer/sharer.php?u=' + encodedCurrentUrl"
          target="_blank"
          rel="noopener"
          (click)="trackShare('facebook')"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M13 22v-8h2.7l.4-3H13V9c0-.9.3-1.5 1.6-1.5H16.3V4.8C16 4.8 15 4.7 13.9 4.7c-2.4 0-4 1.5-4 4.1V11H7.2v3H9.9v8H13z"
            ></path>
          </svg>
        </a>
        <a
          class="fb-share-social"
          title="Pinterest"
          [href]="'https://pinterest.com/pin/create/button/?url=' + encodedCurrentUrl"
          target="_blank"
          rel="noopener"
          (click)="trackShare('pinterest')"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2C6.5 2 4 5.9 4 9.1c0 2 .8 3.7 2.4 4.4.3.1.5 0 .5-.3l.2-.8c.1-.3 0-.4-.2-.6-.4-.5-.7-1.2-.7-2.1 0-2.7 2-5.1 5.3-5.1 2.9 0 4.5 1.8 4.5 4.1 0 3.1-1.4 5.7-3.4 5.7-1.1 0-2-.9-1.7-2.1.3-1.3 1-2.8 1-3.7 0-.9-.5-1.6-1.4-1.6-1.1 0-2 1.2-2 2.7 0 1 .3 1.7.3 1.7l-1.4 5.7c-.4 1.7-.1 3.9 0 4.1 0 .1.2.2.3.1.1-.1 1.6-2 2.1-3.8l.8-3c.4.8 1.6 1.4 2.8 1.4 3.7 0 6.2-3.4 6.2-7.9C20 5.2 17.2 2 12 2z"
            ></path>
          </svg>
        </a>
        <a
          class="fb-share-social"
          title="X"
          [href]="'https://twitter.com/intent/tweet?url=' + encodedCurrentUrl"
          target="_blank"
          rel="noopener"
          (click)="trackShare('x')"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            ></path>
          </svg>
        </a>
        <a
          class="fb-share-social"
          title="LinkedIn"
          [href]="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedCurrentUrl"
          target="_blank"
          rel="noopener"
          (click)="trackShare('linkedin')"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.1c.5-.9 1.8-1.9 3.6-1.9 3.9 0 4.5 2.5 4.5 5.8V21h-4v-5.6c0-1.3 0-3-1.9-3s-2.1 1.4-2.1 2.9V21H9z"
            ></path>
          </svg>
        </a>
        <a
          class="fb-share-social"
          title="Email"
          [href]="'mailto:?subject=Flipbook&body=' + encodedCurrentUrl"
          target="_blank"
          rel="noopener"
          (click)="trackShare('email')"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="5" width="18" height="14" rx="2"></rect>
            <polyline points="3 7 12 13 21 7"></polyline>
          </svg>
        </a>
      </div>

      <button type="button" class="fb-share-close" title="Close" (click)="showShare = false">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="6" y1="6" x2="18" y2="18"></line>
          <line x1="18" y1="6" x2="6" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Grid overlay -->
    <div class="grid-overlay" *ngIf="showGrid">
      <button type="button" class="grid-close" (click)="showGrid = false">×</button>
      <div class="grid-pages">
        <div
          class="grid-item"
          *ngFor="let thumbnail of thumbnails; let i = index"
          [class.active]="currentPage === i + 1"
          [class.search-match]="isSearchMatch(i + 1)"
          (click)="jumpToPage(i + 1)"
        >
          <img *ngIf="thumbnail" [src]="thumbnail" alt="Page thumbnail" />
          <div class="thumbnail-loader" *ngIf="!thumbnail">Loading</div>
          <div class="grid-page-no">
            {{ i + 1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
